export { isIOS, isMobile, isSafari, isMacOS } from "@scrile/tools/dist/lib/browserUtils";

export const IS_BROWSER = process.env.VUE_APP_SERVER === "false";
export const isWebApp = navigator.standalone;
